import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { input } from '@angular/core';

@Component({
  selector: 'ngx-skeleton-item',
  standalone: true,
  imports: [CommonModule],

  template: `
    @for (itemList of items(); track itemList) {
      <div class="flex items-center w-full space-x-2">
        @for (item of itemList; track item; let i = $index) {
          <div
            class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700"
            [ngClass]="[item, i % random === 0 ? 'bg-gray-200' : 'bg-gray-300']"
          ></div>
        }
      </div>
    }
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonItemComponent {
  items = input<string[][]>([]);

  random = Math.floor(Math.random() * 4);
}
